import { render } from "./PanelTipsterHeatmap.vue?vue&type=template&id=bd5720ea&scoped=true"
import script from "./PanelTipsterHeatmap.vue?vue&type=script&lang=js"
export * from "./PanelTipsterHeatmap.vue?vue&type=script&lang=js"

import "./PanelTipsterHeatmap.vue?vue&type=style&index=0&id=bd5720ea&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd5720ea"]])

export default __exports__